/**
 * Task Scoring Configuration
 *
 * This file contains the scoring multipliers used to calculate priority scores
 * for leaf tasks in the todo tree. Each node in the path from root to leaf
 * multiplies the score based on its properties.
 *
 * Higher scores indicate higher priority tasks.
 */

export interface TaskScoringConfig {
  // Base score for each path (before multipliers)
  baseScore: number;

  // Status multipliers (0 = exclude from results)
  status: {
    blocked: number;
    archived: number;
    done: number;
  };

  // Priority multipliers
  priority: {
    low: number;
    medium: number;
    high: number;
    critical: number;
  };
}

/**
 * Default task scoring configuration
 * These values can be easily adjusted to fine-tune the scoring algorithm
 */
export const DEFAULT_TASK_SCORING_CONFIG: TaskScoringConfig = {
  baseScore: 1,

  status: {
    blocked: 0,    // Blocked tasks are excluded
    archived: 0,   // Archived tasks are excluded
    done: 0,       // Completed tasks are excluded
  },

  priority: {
    low: 0.7,      // Low priority reduces score
    medium: 1.0,   // Medium priority is the baseline
    high: 1.2,     // High priority increases score
    critical: 1.6, // Critical priority significantly increases score
  },
};

/**
 * Maximum number of top tasks to display
 */
export const MAX_TOP_TASKS = 10;